<template>
  <div class="incidence-table">
    <h4 class="text-center">
      Taux d'incidence des <strong class='txt-results'>{{type.subtitle}}</strong>
      pour <strong class='txt-reaExplaur'>{{ title }}</strong>
    </h4>
    <table class="table table-responsive">
      <tbody>
        <tr v-for="(l, k) in lines[denominator.code]"
            :key="`line-${k}`">
          <td class="text-center txt-dark-observa4">
            <strong class="incidence-label" v-html="l.label"></strong>
          </td>
          <td class="text-center">
            <span v-if="l.uf !== '__all__'">
              {{ l.uf }}
            </span>
            <span v-else>
              -
            </span>
          </td>
          <td v-for="(c, i) in columns"
              class="text-center"
              :style="{ 'background-color': c.background || '#fff' }"
              :key="`line-${k}-column-${i}`">
            <tooltip v-if="incidences[`${k}.${i}`]"
                     :text="incidences[`${k}.${i}`].tooltip">
              <span role="button" @click="select(l, c)">
                <incidence
                  :value="incidences[`${k}.${i}`].values"
                  :icon="incidences[`${k}.${i}`].icon">
                </incidence>
              </span>
            </tooltip>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import incidence from '@/sui/components/results/incidence'
import results from '@/sui/data/results'

export default {
  name: 'incidence-table',

  props: {
    title: {
      type: String,
      required: true
    },

    type: {
      type: Object,
      required: true
    },

    denominator: {
      type: Object,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    columns: {
      type: Array,
      required: true
    },

    lines: {
      type: Object,
      required: true
    }
  },

  methods: {
    select: function (l, c) {
      this.$emit(
        'select',
        {
          i: this.type,
          d: this.denominator,
          u: l.src,
          p: { disc: l.disc, spe: l.spe },
          c: c
        }
      )
    }
  },

  computed: {
    incidences: function () {
      const result = {}
      const ld = this.lines[this.denominator.code]
      for (let i in ld) {
        const l = ld[i]
        for (let c in this.columns) {
          const col = this.columns[c]
          const key = results.getIncidenceKey(
            {
              inf: this.type.code,
              den: this.denominator.code,
              disc: l.src.disc,
              spe: l.src.spe,
              uf: l.src.uf,
              ent: col.code
            }
          )
          const inc = this.values[key]
          if (inc == null) {
            continue
          }

          const limit = results.getIndicatorLimit(
            this.type.code, l.disc, l.spe, col.code, this.denominator.code
          )

          let tt = ''
          if (inc.divisor != null) {
            tt =
              `<strong>${inc.numerator}</strong> infection.s pour 
<strong>${inc.divisor}</strong> ${this.denominator.info.unit}<hr>`
          }

          let icon = null
          if (limit != null) {
            const out = inc.incidence > limit
            let text = ''
            if (out) {
              icon = { style: 'indicator-nok', icon: 'remove' }
              text = 'supérieur'
            } else {
              icon = { style: 'indicator-ok', icon: 'ok' }
              text = 'inférieur ou égal'
            }

            tt = `${tt}<div class="glyphicon glyphicon-${icon.icon} txt-${icon.style}""></div><br>
<strong class="txt-${icon.style}">Le taux d'incidence est
${text} à la cible de l'indicateur national (${limit}).</strong><hr>`
          }

          tt = `${tt}<small style="opacity: 0.8">Cliquez pour voir le graphique</small>`

          result[`${i}.${c}`] = {
            values: inc,
            tooltip: tt,
            icon: icon
          }
        }
      }
      return result
    }
  },

  components: {
    'incidence': incidence
  }
}
</script>
<style scoped lang="less">
@import '~variables';

.incidence-table {
  .table {
    table-layout: fixed;
  }
  @media (min-width: 0) and (max-width: @screen-xs-max) {
    font-size: 85%;
  }

  .incidence-label {
    small {
      font-size: 70%;
    }
  }
}
</style>
